import { useContext } from "react";

import { NavigationFeatureFlagsContext } from "@/context/navigation-feature-flags-context";

export const useNavigationFeatureFlags = () =>
	useContext(NavigationFeatureFlagsContext);
